"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipTypes = void 0;
var TooltipTypes;
(function (TooltipTypes) {
    TooltipTypes["INLINE"] = "inline";
    TooltipTypes["FIXED_CONTROLLED"] = "controlled";
    TooltipTypes["FIXED_UNCONTROLLED"] = "uncontrolled";
    TooltipTypes["PUSHING_CONTROLLED"] = "pushing_controlled";
})(TooltipTypes = exports.TooltipTypes || (exports.TooltipTypes = {}));
//# sourceMappingURL=TooltipProps.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/Tooltip/TooltipProps.js
// module id = 115
// module chunks = 8